import { NgModule, ErrorHandler } from '@angular/core';
import { IonicApp, IonicModule, IonicErrorHandler } from 'ionic-angular';
import { MyApp } from './app.component';
import { HomePage } from '../pages/home/home';
import { ProjectPage } from "../pages/project/project";
// import { ProjectDataProvider } from "../providers/project-data-provider";

@NgModule({
  declarations: [
    MyApp,
    HomePage,
    ProjectPage
  ],
  imports: [
    IonicModule.forRoot(MyApp)
  ],
  bootstrap: [IonicApp],
  entryComponents: [
    MyApp,
    HomePage,
    ProjectPage,
  ],
  providers: [{provide: ErrorHandler, useClass: IonicErrorHandler}]
})
export class AppModule {}



// WEBPACK FOOTER //
// ./src/app/app.module.ts